// extracted by mini-css-extract-plugin
export default {"app__social":"SocialMedia_app__social__mTBNn","copyright":"SocialMedia_copyright__lwz7B"};